import { ClaimProduct } from 'components/main-page/home-page/claim-product/ClaimProduct'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_CLAIM_PRODUCT } from 'services/api-home-page/apiClaimProduct'
import { convertErrorMessage, uploadFileToS3 } from 'utils/utils'
import { Alert } from 'avo-ui'

const INITIAL_STATE = {
    is_show: false,
    claims: [
        {
            image_url: null,
            title: null,
        },
    ],
}

const GET_FIELD_NAME = {
    claims: 'Claim product item',
}

const GET_ITEM_FIELD_NAME = {
    image_url: 'Image icon',
    title: 'Title',
}

export const ClaimProductContainer = () => {
    const [reload, setReload] = useState(false)
    const [claimProductDetail, setClaimProductDetail] = useState(INITIAL_STATE)
    const copyItems = [...(claimProductDetail?.claims || [])]
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [errorForm, setErrorForm] = useState({})
    const { fetching: getUrlIconImages } = useFetch(API_CLAIM_PRODUCT.URL_IMAGE_ICON)
    const { fetching: getClaimProductDetail, isLoading } = useFetch(API_CLAIM_PRODUCT.DETAIL)
    const { fetching: updateClaimProduct, isLoading: isUpdating } = useFetch(API_CLAIM_PRODUCT.UPDATE)

    const onChangeForm = (item) => {
        setClaimProductDetail({ ...claimProductDetail, ...item })
    }

    const setItems = (items) => {
        setClaimProductDetail({ ...claimProductDetail, claims: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                image_url: null,
                title: null,
            },
        ])
    }

    const setUploadIconImages = async (filesName, uploadDetail) => {
        const newIconImages = [...claimProductDetail?.claims]

        try {
            const s3Urls = await getUrlIconImages({ files: filesName })
            const apiS3list = s3Urls?.data?.map(async (item, i) => {
                await uploadFileToS3(item, uploadDetail[i]?.file)
                newIconImages[uploadDetail[i]?.index] = {
                    ...newIconImages[uploadDetail[i]?.index],
                    [uploadDetail[i]?.key]: `${item?.url}${item?.fields?.key}`,
                }
            })
            await Promise.all(apiS3list)
            onSave({ ...claimProductDetail, claims: newIconImages })
        } catch (err) {
            console.error(err)
        }

        setIsLoadingUpload(false)
    }

    const validateForm = () => {
        const validateIconImages = () => {
            const result = []
            claimProductDetail?.claims?.map((item, index) => {
                Object.keys(item).forEach((key) => {
                    if (GET_ITEM_FIELD_NAME[key] && !item[key]) {
                        result.push({ index, key, message: `${GET_ITEM_FIELD_NAME[key]} wajib diisi` })
                    }
                })
            })
            return result
        }

        return new Promise((resolve, reject) => {
            const errors = {}
            Object.keys(claimProductDetail).forEach((key) => {
                if (GET_FIELD_NAME[key] && claimProductDetail[key]?.length === 0) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (GET_FIELD_NAME[key] && validateIconImages()?.length) {
                    errors['claims_detail'] = validateIconImages()
                }
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        validateForm().then(async () => {
            const iconImages = [...claimProductDetail?.claims]
            const uploadDetail = []
            const filesName = []

            iconImages.map((item, index) => {
                if (item?.image_url?.name) {
                    filesName.push(item?.image_url?.name?.replace(/\s/g, ''))
                    uploadDetail.push({ file: item?.image_url?.file, key: 'image_url', index })
                }
            })

            if (filesName.length) {
                setIsLoadingUpload(true)
                await setUploadIconImages(filesName, uploadDetail)
            } else {
                onSave()
            }
        })
    }

    const onSave = (payload = { ...claimProductDetail }) => {
        const newPayload = {
            ...payload,
            claims: payload?.claims?.map((item, index) => {
                return {
                    ...item,
                    sequence: index,
                }
            }),
        }
        updateClaimProduct(newPayload)
            .then(() => {
                setReload(!reload)
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Claim Product Updated !',
                })
            })
            .catch((error) => setErrorForm(convertErrorMessage(error?.data, GET_FIELD_NAME, GET_ITEM_FIELD_NAME)))
    }

    useEffect(() => {
        getClaimProductDetail().then((response) => setClaimProductDetail({ ...response?.data }))
    }, [reload])

    const props = {
        isShow: claimProductDetail?.is_show,
        items: copyItems,
        setItems,
        onChangeForm,
        onChangeItem,
        onAddNewItem,
        errorForm,
        isLoadingUpload,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <ClaimProduct {...props} />
}
